import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconCube, IconBolt, IconMountain } from '@tabler/icons-react';

import { ZWIFT_MAPS_ASSET } from '../utils/zwiftAssets';

// Showcase for the realistic 3D Zwift maps, illustrated with a real Watopia render
// (the Alpe climb) from assets/zwift_maps. Falls back to a styled placeholder block
// if the image fails to load.

const Zwift3DTeaser = () => {
  const { t } = useTranslation();
  const [imgFailed, setImgFailed] = useState(false);

  return (
    <div className="section-gradient zfix-3d-section">
      <div className="section-inner">
        <div className="zfix-3d">
          <div className="zfix-3d-media">
            {imgFailed ? (
              <div className="zfix-3d-placeholder">
                <IconCube size={56} />
              </div>
            ) : (
              <img
                src={ZWIFT_MAPS_ASSET('Watopia_landscape_1_3D.png')}
                alt={t('fixPage.threeDAlt', 'A realistic 3D map of a Zwift ride climbing the Alpe in Watopia')}
                onError={() => setImgFailed(true)}
              />
            )}
          </div>

          <div className="zfix-3d-text">
            <span className="zfix-3d-badge">{t('fixPage.threeDBadge', 'New')}</span>
            <h2>{t('fixPage.threeDTitle', 'Realistic 3D Zwift maps')}</h2>
            <p>
              {t('fixPage.threeDBody', 'Your indoor rides land on Strava as true-to-life 3D maps of the Zwift worlds, so your feed shows the place you actually rode, terrain and all.')}
            </p>
            <ul className="zfix-3d-list">
              <li>
                <span className="zfix-3d-list-icon"><IconMountain size={18} /></span>
                {t('fixPage.threeDPoint1', 'Real elevation and terrain for every world')}
              </li>
              <li>
                <span className="zfix-3d-list-icon"><IconBolt size={18} /></span>
                {t('fixPage.threeDPoint2', 'Same one-tap auto-fix, now in 3D')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Zwift3DTeaser;
